export const SET_IS_OPEN = "SET_IS_OPEN";
